import { useSyncExternalStore } from 'react';

export type DevComponentPreviewKey =
  | 'authPending'
  | 'authSuccess'
  | 'authError'
  | 'sonnerToast'
  | 'ephemeralBanner'
  | 'billingCancel'
  | 'billingChange'
  | 'agentRename'
  | 'agentDelete'
  | 'attachmentUploadError'
  | 'attachmentValidationError';

export type DevComponentPreviewState = Record<DevComponentPreviewKey, boolean>;

const initial: DevComponentPreviewState = {
  authPending: false,
  authSuccess: false,
  authError: false,
  sonnerToast: false,
  ephemeralBanner: false,
  billingCancel: false,
  billingChange: false,
  agentRename: false,
  agentDelete: false,
  attachmentUploadError: false,
  attachmentValidationError: false,
};

let state: DevComponentPreviewState = initial;
const listeners = new Set<() => void>();

const subscribe = (l: () => void) => {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
};

const getSnapshot = () => state;

export const setDevComponentPreview = (
  key: DevComponentPreviewKey,
  value: boolean,
) => {
  if (state[key] === value) return;
  state = { ...state, [key]: value };
  listeners.forEach((l) => l());
};

export const useDevComponentPreview = (): DevComponentPreviewState =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
